import axiosInstance from "@/api/axiosInstance";
import { UPLOAD_ENDPOINTS } from "../api/endpoints/upload.endpoints";
import { UploadedFileRead } from "@/types/uploads.types";

/** Bump to make every browser fetch image renditions afresh. */
const THUMB_VERSION = 3;

export type { UploadedFileRead, UploadedFileResponse } from "@/types/uploads.types";

export const UploadApi = {
  uploadFile: async (file: File, subFolder?: string): Promise<UploadedFileRead> => {
    const formData = new FormData();
    formData.append("file", file);
    const config = {
      headers: { "Content-Type": "multipart/form-data" },
      params: subFolder ? { sub_folder: subFolder } : {},
    };
    return (await axiosInstance.post<UploadedFileRead>(UPLOAD_ENDPOINTS.UPLOAD_FILE, formData, config)).data;
  },

  /**
   * `width`: images come back as a WebP no wider than that (the original can
   * be several MB). Those URLs are immutable and cached by the browser for a
   * year. Without a width (original file) the request revalidates instead of
   * reusing a copy an <img> tag cached without CORS headers (split-host prod).
   */
  getFileById: async (fileId: number, width?: number): Promise<Blob> => {
    return (await axiosInstance.get(UPLOAD_ENDPOINTS.GET_FILE(fileId), {
      responseType: "blob",
      ...(width
        // `v` versions the browser's copy of a rendition: thumbnails are cached for a year, so a
        // rendition that was made wrong once (an image replaced under the same id) needs a new URL.
        ? { params: { w: width, v: THUMB_VERSION } }
        : { headers: { "Cache-Control": "no-cache" } }),
    })).data;
  },

  deleteFile: async (fileId: number): Promise<void> => {
    await axiosInstance.delete(UPLOAD_ENDPOINTS.DELETE_FILE(fileId));
  },
};